import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "thread-container",
  class: "thread-container bg-white d-flex flex-column h-100"
}
const _hoisted_2 = { class: "thread-list" }
const _hoisted_3 = { class: "thread-item-content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "thread-info" }
const _hoisted_6 = { class: "thread-date" }
const _hoisted_7 = { class: "thread-name" }
const _hoisted_8 = {
  key: 0,
  class: "thread-empty"
}

import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Thread from '../../../api/v2/models/thread'
import api from '../../../api/v2/api'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThreadContainer',
  props: {
    targetableType: { default: 'Lesson' },
    targetableId: {},
    parentTab: { default: 2 }
  },
  emits: ["updateParentTab"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()
const route = useRoute()

const threads = ref<Thread[]>([])
const showDeleteDialog = ref(false)
const showEditDialog = ref(false)
const selectedThread = ref<Thread | null>(null)
const threadName = ref('')

const threadIdQuery = computed(() => getQueryString(route.query, 'thread_id'))

const formatDate = (dateString: string): string => {
  if (!dateString) return ''
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const isActiveThread = (threadId: number): boolean => {
  const currentThreadId = threadIdQuery.value
  return currentThreadId === threadId.toString()
}

const clickThread = (id: number) => {
  emit('updateParentTab', props.parentTab)
  router
    .push({
      query: { ...route.query, thread_id: id.toString() }
    })
    .catch((error) => {
      if (error.name != 'NavigationDuplicated') {
        throw error
      }
    })
}

const openDeleteDialog = (thread: Thread) => {
  selectedThread.value = thread
  showDeleteDialog.value = true
}

const openEditDialog = (thread: Thread) => {
  selectedThread.value = thread
  threadName.value = thread.name
  showEditDialog.value = true
}

const deleteThread = async () => {
  if (!selectedThread.value) return
  try {
    await api.thread.delete(selectedThread.value.id)
    threads.value = threads.value.filter((thread) => thread.id !== selectedThread.value!.id)
    showDeleteDialog.value = false
  } catch (e) {}
}

const editThread = async () => {
  if (!selectedThread.value) return
  try {
    await api.thread.update(selectedThread.value.id, { name: threadName.value })
    selectedThread.value.name = threadName.value
    showEditDialog.value = false
  } catch (e) {}
}

onMounted(async () => {
  try {
    threads.value = await api.thread.index({ targetableId: String(props.targetableId), targetableType: props.targetableType })
  } catch (e) {}
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads.value, (thread) => {
        return (_openBlock(), _createElementBlock("div", {
          key: thread.id,
          class: _normalizeClass(["thread-item", { 'thread-item--active': isActiveThread(thread.id) }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              onClick: _withModifiers(($event: any) => (clickThread(thread.id)), ["prevent"]),
              class: "thread-link"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(formatDate(thread.createdAt)), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_7, _toDisplayString(thread.name || 'New Thread'), 1 /* TEXT */)
              ])
            ], 8 /* PROPS */, _hoisted_4),
            _createVNode(_component_v_menu, { location: "bottom end" }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                  variant: "text",
                  size: "small",
                  icon: "",
                  class: "thread-menu-btn",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("mdi-dots-vertical", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  density: "compact",
                  class: "thread-action-menu"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      onClick: ($event: any) => (openEditDialog(thread)),
                      class: "thread-action-item"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "me-2"
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("mdi-pencil-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("名前の編集", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_v_list_item, {
                      onClick: ($event: any) => (openDeleteDialog(thread)),
                      class: "thread-action-item thread-action-item--danger"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "me-2"
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("mdi-delete-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("削除", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */)),
      (threads.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "grey-lighten-1"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("mdi-chat-outline", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-grey mt-2" }, "スレッドがありません", -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Delete confirm dialog "),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDeleteDialog).value = $event)),
      persistent: "",
      "max-width": "320"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("本当に削除してもよろしいですか？", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  text: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDeleteDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" キャンセル ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  text: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteThread()))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode(" OK ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createCommentVNode(" Edit dialog "),
    _createVNode(_component_v_dialog, {
      modelValue: showEditDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showEditDialog).value = $event)),
      persistent: "",
      "max-width": "350"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("スレッド名の編集", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((threadName).value = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, threadName.value]
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  text: "",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showEditDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" キャンセル ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  text: "",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (editThread()))
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" OK ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})